import React from 'react';
import { Spin } from '../icons/icons';

export const Spinner = ( { loading } ) => (
	<div className={ `nkl-activity-indicator-loader ${ loading ? 'nkl-activity-indicator-loading' : '' }` }>
		<div className="nkl-activity-indicator-container">
			<Spin width={ 24 } height = { 24 } className="nkl-activity-indicator"/>
		</div>
	</div>
);